import React, { useEffect } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom-v5';
import {
  getBenchmarkReportForExportable,
  setBenchmarkReportCategoriesMap,
  setBenchmarkReportIconsMap,
} from 'spw-redux/modules/benchmark-reports/actions';
import { Box } from '@mui/material';
import { colors } from 'spw-theme';
import { BenchmarkReportCardExportables } from 'spw-redux/modules/reports/types';
import { selectBenchmarkReportSummary } from 'spw-redux/modules/benchmark-reports/selectors';
import { useDispatch, useSelector } from 'react-redux';
import BenchmarkReportSummaryCards from '../summary/cards';

const BenchmarkReportExportable = () => {
  const dispatch = useDispatch();
  const route = useRouteMatch<{ reportId: string }>();
  const location = useLocation();
  const searchParams = new URLSearchParams(location?.search);
  const reportSummary = useSelector(selectBenchmarkReportSummary);
  const cardType = searchParams.get(
    'card_type'
  ) as BenchmarkReportCardExportables;
  const linkedProjectsIds = searchParams.get('linked_projects');
  const { reportId } = route.params;

  useEffect(() => {
    const reportCategories = localStorage.getItem('reportCategories');
    const reportIcons = localStorage.getItem('reportIcons');

    if (reportCategories) {
      dispatch(setBenchmarkReportCategoriesMap(JSON.parse(reportCategories)));
    }

    if (reportIcons) {
      dispatch(setBenchmarkReportIconsMap(JSON.parse(reportIcons)));
    }
  }, [dispatch]);

  useEffect(() => {
    const parsedLinkedProjectsIds: number[] = linkedProjectsIds
      ? JSON.parse(linkedProjectsIds)
      : undefined;
    dispatch(
      getBenchmarkReportForExportable({
        reportId: parseInt(reportId, 10),
        linkedProjectsIds: parsedLinkedProjectsIds,
      })
    );
  }, [reportId, linkedProjectsIds, dispatch]);

  return (
    <Box bgcolor={colors.white} className={reportSummary ? 'content' : ''}>
      <BenchmarkReportSummaryCards
        isRenderingForExport
        visibleCardForExportable={cardType}
      />
    </Box>
  );
};

export default BenchmarkReportExportable;
